import { apiSlice } from "../../api/ApiService";

const getPatientRedemptionOverviewApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPatientRedemptionOverview: builder.query({
      query: ({ accessToken }: { accessToken: string | null }) => ({
        url: `/api/v1/Administration/patient-redemption-overview`,
        method: "GET",
        headers: accessToken && { Authorization: `Bearer ${accessToken}` },
      }),
      providesTags: (result, error) => [{ type: "PatientRedemptionOverview" }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetPatientRedemptionOverviewQuery } =
  getPatientRedemptionOverviewApi;
export default getPatientRedemptionOverviewApi;
